import { ContractShow } from 'src/Pages/Contracts/Components/ContractShow';
import { ContractsList } from 'src/Pages/Contracts/Components/ContractsList';

export const contracts = {
  list: ContractsList,
  show: ContractShow,
};
